import axios from '@/axios/index'

// 角色列表
export function getRoleList(data) {
  return axios({
    url: '/api/backstage/role/list',
    method: 'post',
    data
  })
}

// 查看某个角色权限
export function getDetailInfo(data) {
  return axios({
    url: '/api/backstage/role/auth',
    method: 'post',
    data
  })
}

// 新增角色
export function addRole(data) {
  return axios({
    url: '/api/backstage/role/add',
    method: 'post',
    data
  })
}

// 更新某个角色权限/修改角色
export function updateRole(data) {
  return axios({
    url: '/api/backstage/role/update',
    method: 'post',
    data
  })
}

// 删除角色
export function deleteRole(data) {
  return axios({
    url: '/api/backstage/role',
    method: 'delete',
    data
  })
}

// 检测角色名
export function checkRole(data) {
  return axios({
    url: '/api/backstage/role/name/check',
    method: 'post',
    data
  })
}

// 检测角色编码
export function checkRoleCode(data) {
  return axios({
    url: '/api/backstage/role/code/check',
    method: 'post',
    data
  })
}

// 菜单权限标签
export function getMenuLabel(data = {}) {
  return axios({
    url: '/api/label/auth/menu/label',
    method: 'post',
    data
  })
}

// 数据权限标签
export function getDataLabel(data = {}) {
  return axios({
    url: '/api/label/auth/data/label',
    method: 'post',
    data
  })
}
